var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 625.87 338.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#204e84;}.cls-2{fill:#0b8980;}.cls-3{fill:#9ce8e6;opacity:0.3;}.cls-4,.cls-5,.cls-6{fill:#fff;}.cls-4{opacity:0.1;}.cls-5{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 289.9,
    cy: 168.93,
    r: 168.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173,263c25.27-10.93,53.34-13.92,80.4-13.82,22,.07,27.76-11.47,41.18-27,15.65-18.06,39-21.78,62.07-21.79,13.85,0,22.24.49,33.47-8.82,12.26-10.16,15.8-24.28,26.31-35.14,9.63-9.95,24.29-15.54,38.45-18.68a168.06,168.06,0,0,0-12.68-39.72c-16.92,8.29-28.41,23.75-41.35,37.75-18,19.47-29.32,31.57-57.84,32.87-24.57,1.12-50.07.82-65.75,22.67-13.69,19.09-16.65,28.56-43.08,27.21-21.95-1.12-37.81-1-57.56,10.2-12.46,7.08-22.71,17.62-34.68,23.67a168.52,168.52,0,0,0,14.65,21.62A59.29,59.29,0,0,1,173,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M423.17,209.78c-14.26,3.74-30.08,12.2-40.5,22.65-9,9.07-12.82,17.61-25.79,22.7-26.43,10.35-57-4.12-81.08,13.29-18.42,13.33-44.51,37.07-71.38,46.91A168.16,168.16,0,0,0,233,328.43l1.13-.75c21.46-13.76,40.75-11.11,64.62-13.83,35.5-4.05,56.3-50.19,90.66-60.42,13.38-4,28.06-1.17,42-2.24,1.6-.12,3.37-.3,5.25-.54a167.55,167.55,0,0,0,16.8-43.87C441,206.72,428.61,208.36,423.17,209.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.46,171.27c19.8-10.1,22.67-29.26,36.28-44.52,18.18-20.39,33.79-10.84,56.68-7.06C334,124.58,349.76,100,362,76.84,372.06,57.75,384.79,58,405.31,61.06A109.17,109.17,0,0,0,420,62.57a169.87,169.87,0,0,0-28.38-27.64,29.72,29.72,0,0,1-7,1.13c-20,.6-37.23-8.44-50.7,11.28S313.32,85,285.15,83.67c-24.26-1.19-54.61-2.23-70.06,21.54-14.61,22.46-17.69,44.31-50.13,46.5-18.76,1.27-31.67-5.46-44.94,9.52-.12,2.56-.19,5.12-.19,7.7,0,5.45.27,10.83.78,16.14,11.51-4.66,24.47-6.78,35.3-7.31C175.42,176.8,193.92,180.22,211.46,171.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.12,338.07A169,169,0,0,0,330.81,5.65c-1,6.29-.06,13.81,3.58,22.53,13.57,32.45,41.91,58.6,56.18,90.64,29.94,67.18,22.15,145.94-59,167.3-32.9,8.65-73.32,3.27-100.27-17-31.05-23.3-25.83-59.53-20-93.6,5.83-33.88,33.16-87.61,15.41-121.67-4.7-9-22.67-28.72-43-17.59A168.94,168.94,0,0,0,288.12,338.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.81,118.79c-4.75-10.72-21.87-12.22-31.76-14.46-14-3.18-15.21-4.2-24.32-14.11C551.84,73,530.33,73.8,509.6,78.06,493,81.48,473.91,81,460.89,91.63c-6.86,5.63-11.15,10.93-3.75,18.39,7.85,7.93,19.7,3,30.1,3.12,6.61.11,24.62,2.19,19.86,13.35-3.14,7.39-23,3.69-17.08,16.43,4.33,9.3,16,4.77,17.31,19,.95,10.13-3.5,16.3-11.27,21.82C478.73,196,454.38,188,434.53,188c-33.22,0-54.21,7.16-85,19.5-21.94,8.78-41.34,6.06-64.3,4.28-27.26-2.11-55.44,3.06-80.55,13.35-16.64,6.82-46,19.82-51.29-3.12-1.42-6.22,3-7.59-3.15-13.66-3.62-3.58-7.88-3.53-12.44-4.45a73.05,73.05,0,0,0-28.34.22c-10.07,2-55.76,11.21-38.85-15,2.81-4.36,37.13-17.26,48.94-31l1.12-14.77c1.84-20.77-61.68,2.09-69.31,9.5C37.17,166.55,38.22,185.29,25.49,199c-10,10.81-31.73,28.56-23.77,45.6,10.09,21.63,42.41,8,58.91,7.94,29.07-.09,15.58,23.95,29.57,38.79,22.57,23.95,55.08,11.31,81.59,2.3,19.45-6.61,38.28-15.55,58.19-20.75,23.42-6.11,47.56-9,71.14-14.42,48.15-11.08,97.46-11.95,146.39-9.35C482.36,251,568.16,256.4,572,205c.77-10.36-10.13-19.65-8-28.34,2.36-9.73,19.4-11,27.32-13.58C608.11,157.61,633.24,140.06,623.81,118.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M591.28,163.05c16.83-5.44,42-23,32.53-44.26-4.75-10.72-21.87-12.22-31.76-14.46-14-3.18-15.21-4.2-24.32-14.11a44.83,44.83,0,0,0-10.19-8.31c-1,.27-1.94.56-2.9.88-35.74,11.66,16,34.09,19.86,45.12,6.7,19.1-19.51,24.69-33,28.48.31,17.8,3.9,47.85-15.75,55.09-10.75,4-20.61-.53-30.89-2-15.38-2.26-30.88,1.24-46.24,4.31-42.3,8.46-84.07,15.2-126.35,22.71-20.32,3.6-39.63,1.62-59.84,3.4-19.31,1.69-36.71,8-55.51,12.44-21.76,5.13-62.59,16.65-82.69,2.29-8.4-6-10.84-14.93-20.47-19.87-10.32-5.28-21.59-5.28-32.59-7-13.34-2.11-20.1-4.48-27.53-14.74-5.48-7.57-8.83-11.79-17.86-14.26-.1.11-.19.23-.3.34-10,10.81-31.73,28.56-23.77,45.6,10.09,21.63,42.41,8,58.91,7.94,29.07-.09,15.58,23.95,29.57,38.79,22.57,23.95,55.08,11.31,81.59,2.3,19.45-6.61,38.28-15.55,58.19-20.75,23.42-6.11,47.56-9,71.14-14.42,48.15-11.08,97.46-11.95,146.39-9.35C482.36,251,568.16,256.4,572,205c.77-10.36-10.13-19.65-8-28.34C566.32,166.9,583.36,165.62,591.28,163.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.16,233.51l1.13-1.13a1.89,1.89,0,0,0-2.67-2.68l-1.14,1.14a1.89,1.89,0,1,0,2.68,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.16,222.9,62,221.77a1.89,1.89,0,0,0-2.67,2.67l1.13,1.13a1.89,1.89,0,1,0,2.67-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.82,213.28H44.5a1.89,1.89,0,0,0,0,3.78H46a1.89,1.89,0,0,0,0-3.78H44.5a1.89,1.89,0,0,0,0,3.78h.32a1.89,1.89,0,0,0,0-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.82,234.06a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29,243.89h-.53c-.17,0-.43-.08.27,0l-.09,0a1.57,1.57,0,0,1,.69.41l.25.32c.15.4.2.51.14.33s.07.58,0,.29,0-.4,0-.6a1.89,1.89,0,0,0-3.78,0,3.25,3.25,0,0,0,.69,2.33,3,3,0,0,0,2.33.7,1.89,1.89,0,0,0,0-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.4,243.51c0,.22,0,.16,0-.17l.13-.26c-.1.16-.06.11.13-.17s.33-.24.16-.14c.43-.25.28-.1.09-.05l-.21,0c.57-.1.18,0,0,0s-.49,0-.74,0a1.89,1.89,0,1,0,0,3.78,6,6,0,0,0,2.2-.26,2.94,2.94,0,0,0,2-2.76,1.89,1.89,0,0,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.21,239.73a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.75,222.73h1.13a1.89,1.89,0,0,0,0-3.78H18.75a1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.48,221.59a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.29,209.12a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.56,171.71a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.23,168.89l1.14-1.13a1.89,1.89,0,0,0-2.67-2.67l-1.14,1.13a1.89,1.89,0,1,0,2.67,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.63,162.64a1.89,1.89,0,0,0,0-3.77,1.89,1.89,0,0,0,0,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.9,152.44a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.5,155.84a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.07,157.35v1.14a1.89,1.89,0,1,0,3.78,0v-1.14a1.89,1.89,0,0,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.16,170.58a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55,179.65a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46,191h1.14a1.89,1.89,0,1,0,0-3.77H46A1.89,1.89,0,1,0,46,191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.29,193.25a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.38,234.06a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.25,243.13a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152.14,257.11c0-.2,0-.41,0-.61s-.09.51,0,.21-.23.47-.09.19a1.22,1.22,0,0,1,.12-.19c-.35.49-.14.19,0,.08s.39-.41.6-.61a1.89,1.89,0,0,0-2.68-2.67,6.46,6.46,0,0,0-1.3,1.55,4.36,4.36,0,0,0-.38,2.05,1.89,1.89,0,0,0,3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.92,243.13a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.53,242a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.66,263.71l-1.13-1.13a1.89,1.89,0,1,0-2.68,2.67l1.14,1.13a1.89,1.89,0,0,0,2.67-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.38,266.94a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123,285.83h-1.13a1.89,1.89,0,0,0,0,3.78H123a1.89,1.89,0,0,0,0-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107.92,273v-1.13a1.89,1.89,0,1,0-3.77,0V273a1.89,1.89,0,1,0,3.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.39,265.05v-1.14a1.89,1.89,0,1,0-3.77,0v1.14a1.89,1.89,0,1,0,3.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.66,251.44v-1.13a1.89,1.89,0,0,0-3.78,0v1.13a1.89,1.89,0,0,0,3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.42,234.44c0,.18,0,.35,0,.53s-.08.43,0-.27a.32.32,0,0,1,0,.09,1.57,1.57,0,0,1,.41-.69l.32-.25c.4-.15.51-.2.33-.14s.58-.07.29,0-.4,0-.6,0a1.89,1.89,0,1,0,0,3.78,3.23,3.23,0,0,0,2.33-.69,3,3,0,0,0,.7-2.33,1.89,1.89,0,0,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.23,247.29H98.1a1.89,1.89,0,0,0,0,3.78h1.13a1.89,1.89,0,1,0,0-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.83,244.26H80a1.89,1.89,0,1,0,0-3.77H78.83a1.89,1.89,0,1,0,0,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.2,274.87h1.13a1.89,1.89,0,1,0,0-3.78H226.2a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.6,256.73h1.14a1.89,1.89,0,1,0,0-3.77H246.6a1.89,1.89,0,1,0,0,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271.54,260.14h1.14a1.89,1.89,0,1,0,0-3.78h-1.14a1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.4,243.13a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.38,233.31a3.18,3.18,0,0,0,.7,2.32,3,3,0,0,0,2.33.7,1.89,1.89,0,1,0,0-3.78h-.53c-.17,0-.43-.08.26,0l-.09,0a1.59,1.59,0,0,1,.7.4l.25.32c.15.4.2.51.14.34s.06.58,0,.28a5.86,5.86,0,0,1,0-.59,1.89,1.89,0,1,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M260.21,240.86a1.89,1.89,0,0,0,0-3.77,1.89,1.89,0,0,0,0,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.07,247.67a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.28,247.67h1.13a1.89,1.89,0,0,0,0-3.78h-1.13a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.68,253.33h1.13a1.89,1.89,0,0,0,0-3.78h-1.13a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.15,254.47a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.52,227.64a3.22,3.22,0,0,0,.7,2.33,3,3,0,0,0,2.33.69,1.89,1.89,0,0,0,0-3.78H288c-.17,0-.43-.09.26,0l-.09,0a1.59,1.59,0,0,1,.7.4l.25.33c.15.39.2.5.14.33s.06.58,0,.28,0-.39,0-.59a1.89,1.89,0,1,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.67,224.24a3.26,3.26,0,0,0,.69,2.33,3,3,0,0,0,2.33.69,1.89,1.89,0,0,0,0-3.78h-.53c-.17,0-.43-.08.27,0l-.1,0a1.53,1.53,0,0,1,.7.4l.25.33c.15.39.2.5.14.33s.06.58,0,.28a5.86,5.86,0,0,1,0-.59,1.89,1.89,0,1,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.09,235.2a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M406.82,237.84V239a1.89,1.89,0,0,0,3.78,0v-1.13a1.89,1.89,0,0,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M422.31,229.53h1.14a1.89,1.89,0,1,0,0-3.78h-1.14a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M437.43,220.84a3.22,3.22,0,0,0,.69,2.32,3,3,0,0,0,2.33.7,1.89,1.89,0,1,0,0-3.78h-.52c-.18,0-.43-.08.26,0l-.09,0a1.59,1.59,0,0,1,.7.4l.24.32c.15.4.2.51.15.34s.06.58,0,.28a5.86,5.86,0,0,1,0-.59,1.89,1.89,0,1,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M493.73,230.66h1.14a1.89,1.89,0,0,0,0-3.78h-1.14a1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M514.14,238.6h3.4a1.89,1.89,0,0,0,0-3.78h-3.4a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M543.61,229.53a3.21,3.21,0,0,0,2.33-.7,3,3,0,0,0,.69-2.33,1.89,1.89,0,0,0-3.78,0V227c0,.17-.09.43,0-.26l0,.09a1.51,1.51,0,0,1,.41-.7l.32-.25c.39-.15.5-.2.33-.14s.58-.06.28,0a5.76,5.76,0,0,1-.59,0,1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550,215.17V214a1.89,1.89,0,0,0-3.77,0v1.14a1.89,1.89,0,1,0,3.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M513,187.58h1.14a1.89,1.89,0,1,0,0-3.77H513a1.89,1.89,0,1,0,0,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M532.27,193.25h1.14a1.89,1.89,0,0,0,0-3.78h-1.14a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M548.14,191a3.23,3.23,0,0,0,2.33-.69,3,3,0,0,0,.7-2.33,1.89,1.89,0,1,0-3.78,0c0,.18,0,.35,0,.53s-.08.43,0-.27a.3.3,0,0,1,0,.1,1.45,1.45,0,0,1,.4-.7l.32-.25c.4-.15.51-.2.34-.14s.58-.06.28,0-.4,0-.6,0a1.89,1.89,0,0,0,0,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M562.5,169.82v-2.26a1.89,1.89,0,0,0-3.78,0v2.26a1.89,1.89,0,0,0,3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M531.9,158.49v-1.14a1.89,1.89,0,1,0-3.78,0v1.14a1.89,1.89,0,1,0,3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M519.8,149a3.23,3.23,0,0,0,2.33-.69,3,3,0,0,0,.7-2.33,1.89,1.89,0,1,0-3.78,0c0,.17,0,.35,0,.52s-.08.43,0-.26a.29.29,0,0,1,0,.09,1.5,1.5,0,0,1,.4-.7l.32-.24c.4-.16.51-.2.34-.15s.57-.06.28,0-.4,0-.6,0a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M544.74,140h1.14a1.89,1.89,0,0,0,0-3.78h-1.14a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M599.16,140h1.13a1.89,1.89,0,0,0,0-3.78h-1.13a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M619.18,131.28v-1.13a1.89,1.89,0,1,0-3.77,0v1.13a1.89,1.89,0,1,0,3.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M606,121.46h-2.27a1.89,1.89,0,0,0,0,3.78H606a1.89,1.89,0,0,0,0-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M591.22,120.7a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M587.82,116.17a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M474.08,101.81v-1.14a1.89,1.89,0,1,0-3.78,0v1.14a1.89,1.89,0,0,0,3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M484.66,96.9h1.14a1.89,1.89,0,0,0,0-3.78h-1.14a1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M491.46,101.43h1.14a1.89,1.89,0,0,0,0-3.78h-1.14a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M506.2,107.1h1.13a1.89,1.89,0,1,0,0-3.78H506.2a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M525.47,90.09h1.14a1.89,1.89,0,0,0,0-3.78h-1.14a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M551.55,102.56a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535.67,119.57h1.14a1.89,1.89,0,1,0,0-3.78h-1.14a1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M552.68,123a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M555.32,127.88a2.88,2.88,0,0,0,1.51,2.57,5.85,5.85,0,0,0,2.65.45,1.89,1.89,0,0,0,0-3.78h-.62l-.24,0c-.42,0,.45.09,0,0l-.2-.05c-.36-.1.41.21.11,0l.24.18c.19.28.23.33.13.17l.13.27c0,.32,0,.38,0,.16a1.89,1.89,0,1,0-3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M577.24,135.82v-1.14a1.89,1.89,0,0,0-3.78,0v1.14a1.89,1.89,0,0,0,3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565.15,115.79H564a1.89,1.89,0,1,0,0,3.78h1.13a1.89,1.89,0,0,0,0-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565.15,109.36a1.89,1.89,0,0,0,0-3.77,1.89,1.89,0,0,0,0,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M598.78,149.42v-1.13a1.89,1.89,0,0,0-3.78,0v1.13a1.89,1.89,0,0,0,3.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M577.62,155.84h1.13a1.89,1.89,0,0,0,0-3.78h-1.13a1.89,1.89,0,1,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M395.11,203.45a2.87,2.87,0,0,0,2.57-1.5,5.85,5.85,0,0,0,.45-2.65,1.89,1.89,0,1,0-3.78,0c0,.21,0,.41,0,.62a1.93,1.93,0,0,1,0,.24c0,.42.08-.45,0-.06a1.6,1.6,0,0,1,0,.21c-.1.35.22-.41,0-.11l.18-.24c.27-.19.33-.24.16-.14l.27-.12.17,0a1.89,1.89,0,1,0,0,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M414.38,197.79h1.13a1.89,1.89,0,0,0,0-3.78h-1.13a1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M421.18,206.86a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M426.85,212.52a1.89,1.89,0,0,0,0-3.78,1.89,1.89,0,0,0,0,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M437.05,203.45h1.13a1.89,1.89,0,1,0,0-3.77h-1.13a1.89,1.89,0,1,0,0,3.77Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.3cfa14d61e5144c5596d98ef30acd164.svg";
export { ForwardRef as ReactComponent };